export const SIEMENS_STAR_SEGMENTS = 16;

export const TEXT = {
  LARGE_SIZE_RATIO: 0.05,
  MEDIUM_SIZE_RATIO: 0.03,
  SMALL_SIZE_RATIO: 0.015,
  LINE_HEIGHT: 1.2,
};

export const CHART_LABEL_TEXT_SIZE = 30;

export const POSITIONS = {
  TOP_EDGE: 0.1,
  BOTTOM_EDGE: 0.9,
  CENTER: 0.5,
  LEFT_EDGE: 1 / 9,
  RIGHT_EDGE: 8 / 9,
};

export const DIRECTIONS = {
  UP: 0,
  LEFT: 1,
  DOWN: 2,
  RIGHT: 3,
};
